import Vue, { CreateElement, RenderContext, VNode } from "vue";
import { ContentFile } from "@scrile/api-provider/dist/api/ContentFilesProvider";
import { isVideoFile } from "@/lib/fileHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import ContentFeedUnlock from "../ContentFeedUnlock";

interface Props {
  file: ContentFile | undefined;
  size: number;
}

export default Vue.extend({
  functional: true,
  render(h: CreateElement, ctx: RenderContext<Props>): VNode {
    const { file, size } = ctx.props;
    const imageSrc = file
      ? isVideoFile(file)
        ? MediaFilesController.getVideoThumbnail(file.urlPart, "1080p")
        : MediaFilesController.getImageThumbnail(file.urlPart, "1080p")
      : "";
    return imageSrc ? (
      <div
        class={(Array.isArray(ctx.data.class) ? ctx.data.class : [ctx.data.class]).concat([
          ctx.data.staticClass,
          "feed-gallery-locked",
        ])}
        style={(Array.isArray(ctx.data.style) ? ctx.data.style : [ctx.data.style]).concat([ctx.data.staticStyle])}
      >
        <img staticClass={"feed-gallery-locked__image"} src={imageSrc} alt={""} loading={"lazy"} />
        <ContentFeedUnlock staticClass={"feed-gallery-locked__unlock"} size={size} onUnlock={ctx.listeners.unlock} />
      </div>
    ) : (
      <ContentFeedUnlock
        class={{ link: !imageSrc, ...ctx.data.class }}
        style={ctx.data.style}
        size={size}
        onUnlock={ctx.listeners.unlock}
      />
    );
  },
});
